// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import VueCookies from "vue-cookies";
import vueAnalytics from "vue-analytics";
import Meta from "vue-meta";
import { trackers, trackerSettings } from "@/common/consts";
import i18n from "@/common/multilanguage/i18n";
import store from "@/store";
import VueDisqus from "vue-disqus";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from "./firebaseConfig";
import VueScrollTo from "vue-scrollto";

import ExperimentOverride from "@/components/ExperimentOverride/ExperimentOverride.vue";

Vue.use(VueCookies);
Vue.use(Meta);
Vue.use(VueDisqus);
Vue.use(VueScrollTo);

Vue.component("ExperimentOverride", ExperimentOverride);

Vue.prototype.$axios = axios;
Vue.config.productionTip = process.env.NODE_ENV === "production";

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(user => {
    store.dispatch("fetchUser", user);
});

if (typeof window.__PRERENDER_INJECTED === "undefined") {
    Vue.use(vueAnalytics, {
        id: () => Object.values(trackers),
        customIdFields: trackerSettings,
        router,
        ignoreRoutes: ["/dynamic-page/"],
        ready() {
            Vue.$ga.set("dimension2", window.appVersion);
        },
        debug: {
            /** Don't actually hit GA if we're not on production */
            sendHitTask: process.env.NODE_ENV === "production"
        }
    });

    Vue.use(VueScrollTo, {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    });
}

/* eslint-disable no-new */
new Vue({
    el: "#app",
    store,
    router,
    i18n,
    components: { App },
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js